<template>
<div class="chapter">
<div class="inner_page">
<p class="h1bb" id="d7e266435"><span>corn salad</span></p>
<p class="h3" id="d7e266935"><span>(field lettuce, lamb’s tongue, mâche, feldsalat)</span></p>
<p class="h4" id="d7e267435"><span>V<span class="small"><span class="small">ALERIANELLA LOCUSTA</span></span></span></p>
<p class="tx1" id="d7e267935"><span>I used to find corn salad distressingly bland, but I’ve come around. Its soft taste and texture make a good foil for more pungent winter greens. This is a venerable and popular European market plant. It’s easy to grow—almost too easy at times, as its tiny seeds can spread its range rapidly if you let it self-sow. I’ve used it as a winter ground cover; it out-competes many of the weeds that gain footholds in milder winters and is easy to dig under in the spring. Unbruised plants will keep about a week under refrigeration.</span></p>
<p class="h1b" id="d7e271135"><span>dandelions</span></p>
<p class="h4" id="d7e271635"><span>T<span class="small">A<span class="small">RAXACUM OFFICINALE</span></span></span></p>
<p class="tx1" id="d7e272135"><span>In earliest spring, dandelion fanciers dot their yards with upended flower pots to blanch the young growth of their favorite weed. Commercial seed, available from some catalogs, produces a slightly less bitter green, but I doubt the difference is worth the expense. Seeds marketed as Italian dandelion are actually a form of chicory, a different genus. Dandelion greens are used primarily in salads. They are high in vitamin C among other nutrients, though not usually eaten in such quantities as to make that a major consideration. They don’t keep well.</span></p>
<p class="tx" id="d7e275535"><span>Although the roots have the stronger effect, the leaves are also a diuretic (note the French common name, <i>pissenlit</i>), commonly used in herbal tonics. Once the plant flowers, the leaves will be too bitter to eat; however, the sunny flowers can be used to make a traditional dessert wine.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c16_r1.vue?1549c459